import BoxLayoutInspector from './BoxLayoutInspector';

export default function SelectionInspector({ editor }) {
  const { activeWorkflowTab, selectedStructuredItem, selectedStructuredEntry, selectedId,
    setTextNodes, setSelectedId,
    pageLanguage, designPresets, savingTextItems } = editor;
  const selectedArtwork = editor.textNodes?.find((node) => node.id === selectedId);
  const isWhiteCover = selectedArtwork?.type === 'eraser';
  if (activeWorkflowTab === 'output') return <aside aria-label="No settings for this step" />;
  return <aside className="min-w-0 space-y-4 rounded-xl border border-slate-200 bg-white p-4 shadow-sm xl:sticky xl:top-20">
    {selectedStructuredItem ? <BoxLayoutInspector item={{ ...selectedStructuredItem, name: selectedStructuredEntry?.label || selectedStructuredItem.name }}
      presets={designPresets} defaultId={editor.bookDefaultPresetId} canvasSize={editor.canvasSize}
      languages={pageLanguage.split('_')} saving={savingTextItems} onChange={editor.changeLayoutBox}
      onToggleVisibility={() => editor.toggleLayoutBoxVisibility(selectedStructuredItem.id)}
      onSave={() => editor.saveLayoutBox(selectedStructuredItem.id)} onRemove={() => editor.removeLayoutBox(selectedStructuredItem.id)} />
      : selectedId ? <div className="space-y-3">
        <h2 className="text-sm font-semibold">{isWhiteCover ? 'White cover' : 'Image or artwork'}</h2>
        <div className="space-y-2">
          <p className="text-xs text-slate-500">{selectedArtwork?.artworkLayer === 'front' ? 'In front of text and decorations' : 'Behind text and decorations'}</p>
          <div className="flex flex-wrap gap-2">
            <button type="button" className="rounded-lg border border-slate-300 px-3 py-2 text-xs font-semibold hover:bg-slate-50" onClick={() => {
              setTextNodes((current) => {
                const node = current.find((item) => item.id === selectedId);
                return node ? [...current.filter((item) => item.id !== selectedId), { ...node, artworkLayer: 'front' }] : current;
              });
            }}>Bring to front</button>
            <button type="button" className="rounded-lg border border-slate-300 px-3 py-2 text-xs font-semibold hover:bg-slate-50" onClick={() => {
              setTextNodes((current) => {
                const node = current.find((item) => item.id === selectedId);
                return node ? [{ ...node, artworkLayer: 'back' }, ...current.filter((item) => item.id !== selectedId)] : current;
              });
            }}>Send to back</button>
          </div>
        </div>
        {isWhiteCover && <>
          <p className="text-xs text-slate-600">Drag to move. Use the handles or sizes below to cover part of the picture. Your original image stays intact.</p>
          <div className="grid grid-cols-2 gap-3">
            {['x', 'y', 'width', 'height'].map((field) => <label key={field} className="text-xs capitalize">{field}
              <input type="number" aria-label={`White cover ${field}`} min={field === 'width' || field === 'height' ? 10 : undefined}
                step="1" value={Math.round(selectedArtwork[field])} className="mt-1 w-full rounded border border-slate-300 p-2"
                onChange={(event) => {
                  if (event.target.value === '') return;
                  const value = Number(event.target.value);
                  if (!Number.isFinite(value) || ((field === 'width' || field === 'height') && value < 10)) return;
                  const previous = { x: selectedArtwork.x, y: selectedArtwork.y, width: selectedArtwork.width, height: selectedArtwork.height, rotation: selectedArtwork.rotation || 0 };
                  const next = { ...previous, [field]: value };
                  setTextNodes((current) => current.map((node) => node.id === selectedId ? { ...node, ...next } : node));
                  editor.recordMove('artwork', selectedId, previous, next);
                }} />
            </label>)}
          </div>
          <p className="text-xs text-slate-500">Click Render page to include this cover in the saved image. Save layout saves text boxes only.</p>
          <button type="button" className="block text-sm text-blue-700" onClick={() => setSelectedId(null)}>Deselect</button>
        </>}
        <button type="button" className="block text-sm text-red-700" onClick={() => {
          setTextNodes((current) => current.filter((node) => node.id !== selectedId)); setSelectedId(null);
        }}>{isWhiteCover ? 'Remove white cover' : 'Remove selected item'}</button>
      </div> : <p className="text-sm text-slate-600">Select a box in Page layout or on the page to edit its style and placement. Edit wording and translations below the page.</p>}
  </aside>;
}
